// src/components/sections/Presidence.jsx
import React from 'react';
import { useTranslation } from '../../i18n';
import SectionTag from '../common/SectionTag';

const Presidence = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-ofd-cream px-4 md:px-10 py-20" id="presidence">
      <div className="max-w-6xl mx-auto">
        <SectionTag>{t('presidence_tag') || 'Présidence'}</SectionTag>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mt-8">
          {/* Photo */}
          <div className="flex justify-center">
            <div className="relative">
              {/* Cadre avec effet */}
              <div className="absolute -inset-4 bg-gradient-to-r from-ofd-blue via-ofd-yellow to-ofd-red rounded-2xl opacity-20 blur-xl" />
              <div className="relative">
                <img
                  src="/pdg.jpeg"
                  alt="Mme Hadjé Naguiyé Daoud - Présidente de l'OFD"
                  className="w-full max-w-md rounded-2xl shadow-2xl border-4 border-ofd-yellow object-cover"
                  style={{ aspectRatio: '3/4' }}
                />
                {/* Badge tricolore */}
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 flex gap-1 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                  <span className="w-3 h-3 rounded-full bg-[#003F88]" />
                  <span className="w-3 h-3 rounded-full bg-[#F5C300]" />
                  <span className="w-3 h-3 rounded-full bg-[#C8102E]" />
                </div>
              </div>
            </div>
          </div>

          {/* Présentation */}
          <div className="space-y-6">
            <div>
              <h2 className="font-playfair text-3xl md:text-4xl font-bold text-ofd-slate">
                {t('presidence_name') || 'Mme Hadjé Naguiyé Daoud'}
              </h2>
              <p className="text-ofd-blue font-semibold text-lg mt-1">
                {t('presidence_title') || 'Présidente Fondatrice'}
              </p>
            </div>

            <div className="h-1 w-20 bg-ofd-yellow rounded" />

            <p className="text-ofd-gray text-base leading-relaxed">
              {t('presidence_desc1') || 
                'Mme Hadjé Naguiyé Daoud est la Présidente Fondatrice de l\'Organisation des Femmes pour le Développement (OFD). Engagée depuis plus de deux décennies dans la lutte pour l\'émancipation des femmes et le développement communautaire, elle incarne la vision et la détermination qui animent l\'OFD.'}
            </p>

            <p className="text-ofd-gray text-base leading-relaxed">
              {t('presidence_desc2') || 
                'Sous sa direction, l\'OFD est devenue un acteur incontournable du développement socio-économique au Tchad, touchant des milliers de vies à travers des programmes de formation, d\'autonomisation et de solidarité.'}
            </p>

            {/* Citations */}
            <div className="bg-ofd-blue/5 border-l-4 border-ofd-yellow p-4 rounded-r-lg mt-6">
              <p className="text-ofd-slate italic text-sm md:text-base">
                "{t('presidence_quote') || 
                  'La force d\'une nation ne se mesure pas à ses richesses, mais à la manière dont elle élève ses femmes et protège ses plus vulnérables.'}"
              </p>
              <p className="text-ofd-gray text-xs mt-2 font-medium">
                — Mme Hadjé Naguiyé Daoud
              </p>
            </div>

            {/* Informations clés */}
            <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-ofd-gray-light">
              <div className="text-center">
                <div className="text-2xl font-bold text-ofd-blue">+10</div>
                <div className="text-xs text-ofd-gray font-medium uppercase tracking-wider">
                  {t('presidence_years') || 'Années d\'engagement'}
                </div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-ofd-blue">+1000</div>
                <div className="text-xs text-ofd-gray font-medium uppercase tracking-wider">
                  {t('presidence_women') || 'Femmes autonomisées'}
                </div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-ofd-blue">+30</div>
                <div className="text-xs text-ofd-gray font-medium uppercase tracking-wider">
                  {t('presidence_projects') || 'Projets réalisés'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Presidence;